<template>
  <div class="editable-cell">
    <vxe-table
      show-overflow
      keep-source
      ref="xTable"
      :data="tableData"
      :edit-config="{ trigger: 'manual', mode: 'row' }"
      @edit-closed="editClosedEvent"
    >
      <vxe-table-column field="mondayVal" title="周一" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.mondayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="tuesdayVal" title="周二" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.tuesdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="wednesdayVal" title="周三" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.wednesdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="thursdayVal" title="周四" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.thursdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="fridayVal" title="周五" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.fridayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="saturdayVal" title="周六" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.saturdayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="sundayVal" title="周日" :edit-render="{}">
        <template #edit="{ row }">
          <input-number-plus v-model="row.sundayVal" :max="8" :min="0" :precision="2"> </input-number-plus>
        </template>
      </vxe-table-column>
      <vxe-table-column field="control" width="80" title="">
        <template #default="scope">
          <template v-if="$refs.xTable.isActiveByRow(scope.row)">
            <el-button type="text" size="small" @click="saveRowEvent(scope.row)">保存</el-button>
            <el-button type="text" size="small" @click="cancelRowEvent(scope.row)">取消</el-button>
          </template>
          <Icon
            v-else
            @click="$refs.xTable.setActiveRow(scope.row)"
            type="md-create"
            size="18"
            color="#409EFF"
            class="edit-icon"
            style="display: block"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
import InputNumberPlus from '@/components/input/input-number-plus'
import promote_media from '@/data/promote_media'
import { timeout } from '@/common/js/utils'
export default {
  name: 'EditTableColumn',
  components: {
    InputNumberPlus
  },
  props: {
    tableData: {
      type: Array
    }
  },
  computed: {
    transTableData() {
      return JSON.parse(JSON.stringify(this.tableData))
    }
  },
  watch: {
    deep: true,
    transTableData: {
      handler(nVal) {
        // console.log(nVal)
      }
    }
  },
  data() {
    return {
      mediaData: promote_media
    }
  },
  methods: {
    editRow(row) {
      const $table = this.$refs.xTable
      $table.setActiveRow(row)
    },
    saveRowEvent() {
      const $table = this.$refs.xTable
      $table.clearActived().then(() => this.$emit('on-save', this.tableData[0]))
    },
    cancelRowEvent(row) {
      const $table = this.$refs.xTable
      $table.clearActived().then(() => {
        // 还原行数据
        $table.revertData(row)
      })
    },
    editClosedEvent() {
      timeout().then(() => this.cancelRowEvent(this.tableData[0]))
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select--panel {
  z-index: 9997 !important;
  border: 1px solid red;
}

::v-deep .edit-icon {
  display: block;
  cursor: pointer;
  margin-left: 5px;
}
</style>
